// extracted by mini-css-extract-plugin
export var compactFilters = "_f0-4";
export var detailImage = "_f0-1";
export var dropdownContainer = "_f0-2";
export var imageContainer = "_f0-0";
export var selectedCard = "_f0-3";